export default __webpack_public_path__ + "static/media/more_android.59b3c8ba.svg";